(function () {
  'use strict';

  /* @ngdoc object
   * @name vcdms.vcdocument
   * @description
   *
   */
  angular
    .module('vcdms.vcdocument', [
      'ui.router',
      'ui.grid',
      'ui.bootstrap',
      'ngTagsInput'
    ]);
}());
